import { render } from "./Account.vue?vue&type=template&id=06e57734&scoped=true&ts=true"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"

import "./Account.vue?vue&type=style&index=0&id=06e57734&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e57734"]])

export default __exports__